import { IProps } from '../../interfaces/components/image.interface';

const Image = ({ image, className }: IProps) => {
  return (
    <img className={className} src={image.url} alt={image.alt} />
  );
};

export default Image;
